import {catch400, catchUnknownError, postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

export const postArticleRating = (data: {article: number; value: number}): Promise<{article: number; value: number}> => {
    return postRequest({}, apiLink.article.rate({})(null), data)
        .catch(
            catch400((error) => {
                return Promise.reject(error?.appError?.nonFieldErrors || []);
            })
        )
        .catch(catchUnknownError(() => Promise.reject([])));
};
import {catch400, catchUnknownError, postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

export const postArticleRating = (data: {article: number; value: number}): Promise<{article: number; value: number}> => {
    return postRequest({}, apiLink.article.rate({})(null), data)
        .catch(
            catch400((error) => {
                return Promise.reject(error?.appError?.nonFieldErrors || []);
            })
        )
        .catch(catchUnknownError(() => Promise.reject([])));
};
